import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeTone =
  'neutral' | 'primary' | 'active' | 'attention' | 'success' | 'danger' | 'waiter';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-neutral-soft text-neutral-ink',
  primary: 'bg-primary-soft text-primary',
  active: 'bg-active-soft text-active',
  attention: 'bg-attention-soft text-attention-ink',
  success: 'bg-success-soft text-success',
  danger: 'bg-danger-soft text-danger',
  // Reserved: only for "Added by waiter". Do not use for status.
  waiter: 'bg-waiter-soft text-waiter',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
  wrap = false,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
  /** Let a long label wrap onto more lines instead of widening its row. Short status badges stay on one line. */
  wrap?: boolean;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold',
        wrap ? 'max-w-full text-left break-words' : 'whitespace-nowrap',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

/** The one place violet is allowed. */
export function AddedByWaiterBadge() {
  return <Badge tone="waiter">Added by waiter</Badge>;
}
